import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { useRef } from "react";
import { BsFillFolderFill } from "react-icons/bs";

const FrameButton = () => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const orbitRef = useRef<HTMLDivElement | null>(null);
  const centerRef = useRef<HTMLDivElement | null>(null);
  useGSAP(
    () => {
      const containerEl = containerRef?.current;
      const orbitEl = orbitRef?.current;
      const centerEl = centerRef?.current;
      if (!containerEl || !orbitEl || !centerEl) {
        return;
      } else {
        gsap
          .timeline({
            scrollTrigger: {
              trigger: containerEl,
              start: "top center",
              end: "+=60%",
              scrub: true,
            },
          })
          .to(
            orbitEl,
            {
              rotate: "20deg",
            },
            ">",
          )
          .to(
            centerEl,
            {
              rotate: "-20deg",
            },
            "<",
          );
      }
    },
    { dependencies: [containerRef, orbitRef, centerRef] },
  );
  return (
    <>
      <div ref={containerRef} className="w-full h-full relative">
        <div
          ref={orbitRef}
          className="w-fit h-fit cursor-pointer -rotate-80  flex flex-col justify-center items-center gap-4 absolute top-1/2 left-1/2 -translate-1/2"
        >
          <div
            onClick={() => {
              alert("Hello !");
            }}
            className="w-fit px-7 cursor-pointer py-3 flex items-center justify-center text-white relative bg-black rounded-4xl"
          >
            <div className="absolute bottom-0 translate-y-1/3 left-1/2 w-5 bg-black aspect-square -translate-x-1/2 rotate-45"></div>
            See All Projects
          </div>
          <div
            onClick={() => {
              alert("Hello !");
            }}
            ref={centerRef}
            className="w-24 h-24 cursor-pointer rounded-full bg-[#e0e0e0]  flex items-center justify-center"
          >
            <BsFillFolderFill className="text-xl text-[#111212]" />
          </div>
        </div>
      </div>
    </>
  );
};

export default FrameButton;
